var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-textarea',{attrs:{"label":"Введите цитату"},on:{"input":function($event){return _vm.$emit("update", _vm.block)}},model:{value:(_vm.block.value),callback:function ($$v) {_vm.$set(_vm.block, "value", $$v)},expression:"block.value"}})}
var staticRenderFns = []

export { render, staticRenderFns }